export const style = {
  className: 'myartprice-bar',
  backgroundColor: '#fff',
  borderColor: '#f1f1f1',
  paddingBottom: 5,
  paddingTop: 20,
};
